import HeaderMain from "../components/header/HeaderMain";
import NavMain from "../components/nav/NavMain";
import ReportOutstandingBalancePerProduct from "../reports/ReportOutstandingBalancePerProduct";


function OutstandingBalanceReportPerProduct() {
    return (
        <>
            <NavMain slug="outstanding-balance-report-per-product" parent="3" />
            <HeaderMain slug="outstanding-balance-report-per-product" />
            <div className="main-content">
                <ReportOutstandingBalancePerProduct />
            </div>
        </>
    );
}

export default OutstandingBalanceReportPerProduct;